import { useEffect, useState } from 'react'


import WordCloud from './wordcloud'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'

const Skills = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const skillsArray = 'Skills'.split('')

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      <div className="container skills-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={skillsArray}
              idx={15}
            />
            <br />
          </h1>
          <p>My toolkit spans software development, backend services, and security. I work with C++, Python, JavaScript, TypeScript, SQL, and C.</p>
          <p>React, Tailwind CSS, Node.js, FastAPI, PostgreSQL, and Supabase for applications and REST APIs. Git, Linux, pytest, and GitHub Actions for testing and CI workflows.</p>
          <p>Security work includes authorization, access control, tenant isolation, parameterized SQL, and permission boundaries.</p>
        </div>

        <div className="tagcloud-wrap">
          <WordCloud />
        </div>
      </div>

    </>
  )
}

export default Skills
